// External libraries
import React from 'react';
import { useStoreState } from '@/store';
// @ts-expect-error untyped-import
import { FieldError } from '@checkout/react-components';

// Internal modules
import { getContent } from '@/lib';
import {
  errorStyleOverrides,
  PrivacyTermsContainer,
  PrivacyTermsList,
} from './StyledComponents';
import { getPrivacyStatementLinks } from './utils';
import { getPrivacyPolicyEmbeddedLink } from '../../../OnboardTerms/StreamlineOnboardTerms/streamlineTermsEmbeddedLinks';
import type { InputOnChange } from '@/types';
import { Checkbox } from '@/components/Common';

type PrivacyStatementProps = {
  changeHandler: InputOnChange;
};

const PrivacyStatement = ({
  changeHandler,
}: PrivacyStatementProps): JSX.Element => {
  const isFormSubmitting = useStoreState(({ ui }) => ui.isFormSubmitting);
  const signupAgreePrivacyStatements = useStoreState(
    ({ form }) => form.signupAgreePrivacyStatements,
  );
  const hasError = Boolean(signupAgreePrivacyStatements?.displayError);
  const label = getContent('terms.privacyStatement.header', {
    privacyStatementLink: getPrivacyPolicyEmbeddedLink({
      embeddedLinkText: 'terms.privacyStatement.privacyStatement',
      flowType: 'signup',
    }),
  });

  const multipleLabels = getPrivacyStatementLinks();
  return (
    <PrivacyTermsContainer>
      <Checkbox
        testID="signupAgreePrivacyStatements"
        aria-describedby={hasError ? 'privacy-statements-error' : null}
        aria-invalid={hasError}
        changeHandler={changeHandler}
        checked={signupAgreePrivacyStatements?.value}
        disabled={isFormSubmitting}
        id="signupAgreePrivacyStatements"
        label={label}
        isTermsCheckbox
        name="signupAgreePrivacyStatements"
        required={true}
        {...signupAgreePrivacyStatements}
      />
      <PrivacyTermsList>
        {multipleLabels.map(subTerms => {
          return <li key={subTerms.key}>{subTerms.element}</li>;
        })}
      </PrivacyTermsList>
      {hasError && (
        <FieldError
          id="privacy-statement-error"
          styleOverrides={errorStyleOverrides}
        >
          {getContent('fieldErrors.common.valueMissing')}
        </FieldError>
      )}
    </PrivacyTermsContainer>
  );
};

export { PrivacyStatement };
